import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import SearchIcon from '@mui/icons-material/Search';
import Box from '@mui/material/Box';
import FormHelperText from '@mui/material/FormHelperText';
import { alpha } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { VARIANT, SIZE } from '../constants/inputConstants.js';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';

var StyledTextFieldContainer = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "ealhl1j5"
} )(function (_ref) {
  _ref.theme;
  return {
    '& *': {
      fontFamily: "'Inter', sans-serif, 'Noto Sans CJK TC', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4'"
    }
  };
}, "" );
var StyledInputTitle = /*#__PURE__*/_styled('div', {
  shouldForwardProp: isStyledPropsValid,
  target: "ealhl1j4"
} )(function (_ref2) {
  var theme = _ref2.theme;
  return {
    fontSize: theme.fontSize.MEDIUM,
    marginBottom: '4px',
    color: theme.customColors.grey[700],
    display: 'flex'
  };
}, "" );
var StyledInputTitleRequired = /*#__PURE__*/_styled('div', {
  shouldForwardProp: isStyledPropsValid,
  target: "ealhl1j3"
} )(function (_ref3) {
  var theme = _ref3.theme;
  return {
    color: theme.customColors.pink[600],
    marginLeft: '5px'
  };
}, "" );
var StyledTextField = /*#__PURE__*/_styled(TextField, {
  shouldForwardProp: isStyledPropsValid,
  target: "ealhl1j2"
} )(function (_ref4) {
  var theme = _ref4.theme,
    size = _ref4.size,
    color = _ref4.color,
    multiline = _ref4.multiline,
    backgroundColor = _ref4.backgroundColor;
    _ref4.error;
    var isStartAdornmentExist = _ref4.isStartAdornmentExist;
    _ref4.disabled;
    var variant = _ref4.variant;
    _ref4.type;
    var customColor = _ref4.customColor;
  return {
    '& .MuiInputBase-root': _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
      backgroundColor: backgroundColor || theme.customColors.white,
      paddingRight: '12px'
    }, multiline && {
      padding: '10px 5px 10px 10px',
      alignItems: 'flex-start'
    }), size === SIZE.XL && !multiline && {
      height: '40px'
    }), size === SIZE.LARGE && !multiline && {
      height: '36px'
    }), size === SIZE.MEDIUM && !multiline && {
      height: '32px'
    }), size === SIZE.SMALL && !multiline && {
      height: '28px',
      fontSize: '12px'
    }), size === SIZE.XS && !multiline && {
      height: '24px',
      fontSize: '12px'
    }), size === SIZE.XSS && !multiline && {
      height: '16px',
      fontSize: '12px'
    }), {}, {
      '& *': {
        fontFamily: "'Inter', sans-serif, 'Noto Sans CJK TC', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4'"
      },
      '&.Mui-error': {
        background: theme.customColors.pink[100],
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.customColors.pink[600]
        },
        '&.Mui-focused': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderWidth: "1px"
          }
        }
      },
      '&.Mui-disabled': {
        background: theme.customColors.grey[200],
        '& .MuiOutlinedInput-notchedOutline': {
          border: "1px solid ".concat(theme.customColors.grey[300])
        }
      },
      '&:not(.Mui-disabled, .Mui-error)': {
        '&.Mui-focused': {
          '& .MuiOutlinedInput-notchedOutline': {
            border: "1px solid ".concat(customColor || theme.palette[color].main),
            boxShadow: "".concat(alpha(customColor || theme.palette[color].main, 0.5), " 0px 0px 0px 2px")
          }
        },
        '&:hover': {
          '& .MuiOutlinedInput-notchedOutline': {
            border: "1px solid ".concat(customColor || theme.palette[color].main)
          }
        }
      }
    }, isStartAdornmentExist && {
      paddingLeft: '12px',
      '& i': {
        color: theme.customColors.grey[700]
      },
      '& .MuiSvgIcon-root': {
        width: '16px',
        height: '16px'
      }
    }), variant === VARIANT.STANDARD && {
      '&.Mui-focused': {
        '&:after': {
          transform: 'scaleX(0)'
        }
      },
      '&.Mui-error': {
        background: 'unset'
      },
      '&:hover': {
        '&:not(.Mui-disabled, .Mui-error)': {
          '&:before': {
            borderBottom: "1px solid ".concat(customColor || theme.palette[color].main)
          }
        }
      },
      '&:before': {
        borderBottom: "1px solid ".concat(theme.customColors.grey[400])
      },
      '&.Mui-disabled': {
        '&:before': {
          borderBottomStyle: 'solid',
          borderBottom: "1px solid ".concat(theme.customColors.grey[300])
        }
      }
    }),
    '& .MuiInputBase-input': _objectSpread2(_objectSpread2(_objectSpread2({
      color: theme.customColors.grey[700],
      padding: multiline ? 0 : '12px',
      height: '16px',
      '&::-webkit-scrollbar': {
        width: '4px'
      },
      '&::-webkit-scrollbar-track': {
        background: theme.customColors.grey[300]
      },
      '&::-webkit-scrollbar-thumb': {
        background: theme.customColors.grey[500],
        borderRadius: '5px'
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: theme.customColors.grey[500]
      }
    }, size === SIZE.MEDIUM && {
      padding: '11px 12px',
      height: '10px'
    }), isStartAdornmentExist && {
      paddingLeft: '5px'
    }), {}, {
      '&.Mui-disabled': {
        WebkitTextFillColor: theme.customColors.grey[400],
        '&::placeholder': {
          color: theme.customColors.grey[400]
        }
      },
      '&::placeholder': _objectSpread2(_objectSpread2(_objectSpread2({
        opacity: 1,
        color: theme.customColors.grey[500],
        fontSize: '14px'
      }, size === SIZE.SMALL && {
        fontSize: '12px'
      }), size === SIZE.XS && {
        fontSize: '12px'
      }), size === SIZE.XSS && {
        fontSize: '12px'
      })
    }),
    '& .MuiOutlinedInput-notchedOutline': {
      border: "1px solid ".concat(theme.customColors.grey[300]),
      borderRadius: '3px'
    },
    '& input[type="search"]::-webkit-search-decoration': {
      WebkitAppearance: 'none'
    },
    '& input[type="search"]::-webkit-search-cancel-button': {
      WebkitAppearance: 'none'
    },
    '& input[type="search"]::-webkit-search-results-button': {
      WebkitAppearance: 'none'
    },
    '& input[type="search"]::-webkit-search-results-decoration': {
      WebkitAppearance: 'none'
    }
  };
}, "" );
var StyledFormHelperText = /*#__PURE__*/_styled(FormHelperText, {
  shouldForwardProp: isStyledPropsValid,
  target: "ealhl1j1"
} )(function (_ref5) {
  var theme = _ref5.theme,
    errorTextAbsolute = _ref5.errorTextAbsolute;
  return _objectSpread2({
    '&.Mui-error': {
      color: theme.customColors.pink[600]
    },
    fontFamily: "'Inter', sans-serif, 'Noto Sans CJK TC', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4'",
    fontSize: '14px',
    marginTop: 0,
    lineHeight: 1.25
  }, errorTextAbsolute && {
    position: 'absolute'
  });
}, "" );
var StyledSearchIcon = /*#__PURE__*/_styled(SearchIcon, {
  shouldForwardProp: isStyledPropsValid,
  target: "ealhl1j0"
} )(function (_ref6) {
  var theme = _ref6.theme;
  return {
    color: theme.customColors.grey[500]
  };
}, "" );

export { StyledFormHelperText, StyledInputTitle, StyledInputTitleRequired, StyledSearchIcon, StyledTextField, StyledTextFieldContainer };
